app.controller("AddSysparamController", ["$scope", "$uibModalInstance", "SysParam",
    function ($scope, $uibModalInstance, SysParam) {
        $scope.format = "dd-MM-yyyy";
        $scope.popup1 = {
            opened: false
        };

        $scope.types = [{
            _id: 'String',
            name: 'ტექსტი'
        }, {
            _id: 'Number',
            name: 'რიცხვი'
        }, {
            _id: 'Date',
            name: 'თარიღი'
        }];

        $scope.type = $scope.types[0];

        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };

        $scope.create = function () {
            SysParam.createSysParam({
                key: $scope.key,
                name: $scope.name,
                description: $scope.description,
                value: $scope.value,
                type: $scope.type._id
            }).then(function (created) {
                if (created) {
                    $uibModalInstance.close();
                }
            })
        };
        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);